import { FeatureType, ICAMSKey, IMapInteractionConfig, IAPIResult, TextPack } from '../Models/UtilityModels';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ActivityListRequestModel, ActivityListType, ActivityListFilter } from '../Activity/Activity';
import { ICAMSContact, ContactListConfig } from '../Contacts/ContactsModels';
import { Photos } from '../Photos/Photos';
import { Tasks_Assign } from './Tasks_Assign';

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Tasks_Groups {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private photos: Photos = new Photos();

    // ----------------------------------------------------------- //
    // Defaults
    // List of buttions in the action toolbar
    private actionBtns = {
        map: { btn: null, enable: false },
        accept: { btn: null, enable: false },
        reject: { btn: null, enable: false },
        complete: { btn: null, enable: false },
        note: { btn: null, enable: false },
        annotate: { btn: null, enable: false }
    };

    // ----------------------------------------------------------- //
    //Constructor
    public constructor(protected Tasks_Assign: Tasks_Assign) {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // OPEN PANELS
    public openTaskGroupViewPanel = (camsKey: ICAMSKey, showClass: string = 'show', closeCallback: Function): void => {
        const self = this;
        Utilities.BlockUI($('#featureDetailsPanel'));
        $('#featureDetailsPanel').addClass(showClass);
        $('#featureDetailsPanel').load(window.G_SITEFOLDERNAME +'/Tasks/TaskGroupView', { taskGroupID: camsKey.uid }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }

            $('#taskGroupViewPanelCloseBtn').on('click', function () { $('#featureDetailsPanel').removeClass(showClass); closeCallback(); });

            $('#taskGroupViewActivityBtn').on("click", function () {
                let model: ActivityListRequestModel = { ID: camsKey.uid.toString(), ActivityListType: ActivityListType.TaskGroupActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
                events.bus.publish(events.eventShowActivityList([$(this), model, $('#taskGroupEditModal')]));
                this.blur();
            });

            // MAP ZOOM BTN
            $('#featureDetailsPanel [data-zoommap]').on("click", function () {
                const data: ICAMSKey = $(this).data("zoommap");
                events.bus.publish(events.eventZoomToAnyFeature([data, true, null]));
            });

            // EDIT BTN
            $('#featureDetailsPanel [data-editatr]').on("click", function () {
                const data: ICAMSKey = $(this).data("editatr");
                self.openTaskGroupEditPanel(data);
                $('#featureDetailsPanel').removeClass(showClass);
                closeCallback();
            });

            // Override what the photo click does
            setTimeout(function () {
                $('#featureDetailsPanel #camsLibraryLinkContainer .card').off('click');
                $('#featureDetailsPanel #camsLibraryLinkContainer .card').on('click', function () {
                    var index = $('#featureDetailsPanel #camsLibraryLinkContainer .card').index($(this));
                    var imgs = $('#featureDetailsPanel #camsLibraryLinkModalGallery').find('img');

                    var url = imgs[index].getAttribute('src');
                    self.photos.showPhotoModal(url);
                });
            }, 500);

            // Check buttons
            self.bindButtons(camsKey);
            self.checkVisibleButtons(camsKey);
        });
    }

    // ----------------------------------------------------------- //
    // VIEW Buttons
    private checkVisibleButtons = (data: ICAMSKey): void => {
        const self = this;

        // Reset all btns first
        Object.keys(this.actionBtns).forEach(k => { self.actionBtns[k].enable = false; });

        self.actionBtns.map.enable = true;
        self.actionBtns.accept.enable = true;
        self.actionBtns.note.enable = true;
        self.actionBtns.annotate.enable = true;
        self.actionBtns.reject.enable = true;
        self.actionBtns.complete.enable = true;

        Object.keys(this.actionBtns).forEach(k => {
            if (self.actionBtns[k].enable == true) self.actionBtns[k].btn.prop("disabled", false);
            else self.actionBtns[k].btn.prop("disabled", true);
        });
    }

    private bindButtons = (data: ICAMSKey): void => {
        const self = this;

        self.actionBtns = {
            map: { btn: $('#taskGroupsViewShowMapBtn'), enable: false },
            accept: { btn: $('#taskGroupsViewAcceptBtn'), enable: false },
            reject: { btn: $('#taskGroupsViewRejectBtn'), enable: false },
            complete: { btn: $('#taskGroupsViewCompleteBtn'), enable: false },
            note: { btn: $('#taskGroupsViewNoteBtn'), enable: false },
            annotate: { btn: $('#taskGroupsViewAnnotateBtn'), enable: false }
        };
        
        self.actionBtns.map.btn.on("click", function () {
            events.bus.publish(events.eventZoomToWKTandHighlight([[data.wkt], true, true, null]));
            this.blur();
        });

        self.actionBtns.accept.btn.on("click", function () {
            events.bus.publish(events.eventOpenTasksAcceptPanel(data));
            this.blur();
        });
        self.actionBtns.reject.btn.on("click", function () {
            events.bus.publish(events.eventOpenTasksRejectPanel(data));
            this.blur();
        });
        self.actionBtns.complete.btn.on("click", function () {
            if (data.featureType == FeatureType.Task) events.bus.publish(events.eventOpenTasksCompletePanel([data, true, null]));
            else if (data.featureType == FeatureType.TaskGroup) events.bus.publish(events.eventOpenTaskGroupsCompletePanel(data));
            this.blur();
        });
        self.actionBtns.note.btn.on("click", function () {
            events.bus.publish(events.eventOpenNotificationQueryPanel([data, null]));
            this.blur();
        });
        self.actionBtns.annotate.btn.on("click", function () {
            events.bus.publish(events.eventShowAnnotationsForFeature([data, true]));
            this.blur();
        });
    }

    // ----------------------------------------------------------- //
    // CREATE Form
    public openTaskGroupCreatePanel = (taskIDs: Array<string>): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(window.G_SITEFOLDERNAME +'/Tasks/TaskGroupCreate', { taskIDs: taskIDs }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskGroupCreateModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#taskGroupCreateModal');

            $('#taskGroupCreateContactListBtn').on("click", function () {
                Utilities.GetModal('#taskGroupCreateModal', ModalAction.Hide);

                var camsKeys: Array<ICAMSKey> = [];
                taskIDs.forEach(t => { camsKeys.push({ code: t.toString(), 'featureType': FeatureType.Task }) });
                self.Tasks_Assign.openAssignPanel(camsKeys, {submitResponse: false, showUnassignBtn: false}, function (contactData: ICAMSContact) {
                    if (contactData != null) {
                        $('#taskGroupCreateModal [name="AssignedToListName"]').val(contactData.ListName);
                        $('#taskGroupCreateModal [name="AssignToContactRef"]').val(contactData.ContactRef);
                        $('#taskGroupCreateModal [name="AssignToType"]').val(contactData.ContactType);

                        if (contactData.ListName == null || contactData.ListName == '') $('#taskGroupCreateModal [name="AssignedToListName"]').val(contactData.ContactTypeDescr);
                    }
                    Utilities.GetModal('#taskGroupCreateModal', ModalAction.Show);
                })
            });

            // Get form validation
            Utilities.InitFormValidation($("#taskGroupCreateForm"));

            $('#taskGroupCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskGroupCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#taskGroupCreateModal .modal-content"));
                let formData = new FormData(<any>$('#taskGroupCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Tasks/CreateTaskGroup',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                            }
                            else {
                                Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_CreateFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskGroupCreateModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#taskGroupCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskGroupCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskGroupCreateModal', ModalAction.Hide);
            });

        });
    }

    // ----------------------------------------------------------- //
    // EDIT Form
    public openTaskGroupEditPanel = (camsKey: ICAMSKey): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-taskmodals').load(window.G_SITEFOLDERNAME +'/Tasks/TaskGroupEdit', { taskGroupID: camsKey.uid }, function (response, status, xhr) {
            Utilities.UnBlockUI();

            Utilities.GetModal('#taskGroupEditModal', ModalAction.Create);

            //initialise photo uploader
            self.photos.setupUploader('#taskGroupEditModal');

            $('#taskGroupEditActivityBtn').on("click", function () {
                let model: ActivityListRequestModel = { ID: camsKey.uid.toString(), ActivityListType: ActivityListType.TaskGroupActivity, Filter: ActivityListFilter.All, Skip: 0, Take: 7 };
                events.bus.publish(events.eventShowActivityList([$(this), model, $('#taskGroupEditModal')]));
                this.blur();
            });
            $('#taskGroupEditContactListBtn').on("click", function () {
                //self.openAssignedTasksForm();
                toastr.info("To be completed");
                this.blur();
            });

            // Get form validation
            Utilities.InitFormValidation($("#taskGroupEditForm"));

            $('#taskGroupEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#taskGroupEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#taskGroupEditModal .modal-content"));
                let formData = new FormData(<any>$('#taskGroupEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: '/Tasks/UpdateTaskGroup',
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated task group!');
                            }
                            else {
                                toastr.error('Failed to update task group!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            alert(err);
                        }
                        finally {
                            Utilities.GetModal('#taskGroupEditModal', ModalAction.Hide);
                            Utilities.UnBlockUI($("#taskGroupEditModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#taskGroupEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#taskGroupEditModal', ModalAction.Hide);
            });

        });
    }

    
}




